import React, {useContext, useState} from "react";
import {
  Button,
  Fade,
  IconButton, MenuItem, Select, Slider,
  Stack,
  TextField
} from "@mui/material";
import Box from "@mui/material/Box";
import {HugeiconsIcon} from "@hugeicons/react";
import {Cancel01Icon} from "@hugeicons/core-free-icons";
import {grey} from "@mui/material/colors";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {WebSettingsContext} from "../../../../../context/WebSettingsContext";
import {v4 as uuid} from "uuid";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: "320px",
  maxWidth: "640px", width: "90%",
  maxHeight: "60vh",
  bgcolor: 'background.paper',
  borderRadius: 3,
  border: '0px solid #000',
  boxShadow: 24,
  overflowY: "auto"
};

const initState = {
  name: "",
  model_group: "",
  model_name: "",
  validation_instructions: "",
  max_output_tokens: 0,
}


export const CreateWatchdog = ({open, handleClose, selectedWatchdog, handleSubmit, project}) => {
  const {settings, modelIds} = useContext(WebSettingsContext);
  const [watchdog, setWatchdog] = useState({...initState})

  const onCreate = () => {
    const data = {...project};
    const newCollection = selectedWatchdog ? {...selectedWatchdog, ...selectedWatchdog} : {...watchdog, id: uuid()};
    if (!data?.watchdogs) {
      data.watchdogs = [];
    }
    if (selectedWatchdog) {
      data.watchdogs = data?.watchdogs?.map(i => i.id === newCollection.id ? {...newCollection} : {...i});
    } else {
      data.watchdogs.push(newCollection);
    }

    handleSubmit(data);
    handleClose();
  }

  const onDelete = async () => {
    if (!selectedWatchdog) {
      return;
    }
    const data = {...project};
    data.watchdogs = data?.watchdogs?.filter(i => i?.id !== selectedWatchdog?.id) || []

    handleSubmit(data);
    handleClose();
  }


  const onClose = () => {
    setWatchdog({...initState});
    handleClose();
  }

  const onChange = event => {
    const key = event.target.name;
    const value = event.target.value;

    if (key) {
      onUpdate(key, value === "none" ? null : value);
    }
  }

  const onUpdate = (key, value) => setWatchdog(prev => ({...prev, [key]: value}))


  return (
    <>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Fade in={open} timeout={500}>
          <Box>
            <Box sx={{position: "fixed", top: 10, right: 10}}>
              <IconButton
                size={"small"}
                onClick={onClose}
                color={"#FFF"}
              >
                <HugeiconsIcon icon={Cancel01Icon} color={grey[300]}/>
              </IconButton>
            </Box>

            <Stack direction={"column"} gap={0} sx={style}>
              <Box sx={{p: 2}}>
                <Typography variant={"h4"} fontWeight={"bold"}>{selectedWatchdog ? "Update" : "Create"} Watchdog</Typography>
              </Box>
              <Stack direction={"column"} gap={1} sx={{flex: 1, overflowY: "auto", px: 3}}>
                <Box>
                  <Typography fontWeight={600} gutterBottom>Name:</Typography>
                  <TextField
                    size={"small"} placeholder={"Enter name of the tool"}
                    helperText={"Name should be unique"}
                    value={watchdog?.name} autoFocus fullWidth
                    name={"name"}
                    onChange={onChange}
                  />
                </Box>

                <Box>
                  <Typography fontWeight={600} gutterBottom>Model Group:</Typography>
                    <Select
                      value={watchdog?.model_group || "none"}
                      onChange={onChange}
                      name={"model_group"}
                      size={"small"} fullWidth
                    >
                      <MenuItem value={"none"}><em>None</em></MenuItem>
                      <MenuItem value={"chat-gpt"}>Chat GPT</MenuItem>
                      <MenuItem value={"deep-seek"}>Deep Seek</MenuItem>
                      <MenuItem value={"custom"}>Custom</MenuItem>
                    </Select>
                </Box>

                <Box>
                  <Typography fontWeight={600} gutterBottom>Model Group:</Typography>
                  <Select
                    value={watchdog?.model_name || "none"}
                    onChange={onChange} name={"model_name"}
                    size={"small"} fullWidth
                  >

                    {modelIds?.map(model => {
                      return (
                        <MenuItem key={model} value={model}>{model}</MenuItem>
                      )
                    })}

                  </Select>
                </Box>

                <Box>
                  <Typography fontWeight={600} gutterBottom>Validation Instruction:</Typography>
                  <TextField
                    size={"small"} placeholder={"Enter validation instructions"}
                    value={watchdog?.validation_instructions} autoFocus fullWidth
                    name={"validation_instructions"}
                    onChange={onChange}
                  />
                </Box>

                <Box>
                  <Typography fontWeight={600} gutterBottom>MAX Output Tokens:</Typography>

                  <Stack direction={"row"} alignItems={"center"} gap={2} sx={{width: "90%", px: 2}}>
                    <Typography sx={{minWidth: 40}}>{watchdog?.max_output_tokens}</Typography>
                    <Slider
                      sx={{flex: 1}} size={"small"}
                      value={watchdog?.max_output_tokens || 0}
                      min={0} max={512} step={1}
                      onChange={e => onUpdate("max_output_tokens", e.target.value)}
                    />
                  </Stack>
                </Box>

              </Stack>

              <Stack direction={'row'} gap={1} useFlexGap flexWrap={"wrap"} justifyContent={"flex-end"} sx={{p: 2}}>
                {
                    selectedWatchdog && <Button
                        variant={"outlined"}
                        color={"error"}
                        size={"small"}
                        sx={{borderRadius: 2, textTransform: "capitalize", mr: "auto"}}
                        onClick={onDelete}
                    >
                      Delete
                    </Button>
                }
                <Button
                    variant={"ghost"}
                    color={"secondary"}
                    size={"small"}
                    sx={{borderRadius: 2, minWidth: 100, textTransform: "capitalize"}}
                    onClick={onClose}
                >
                  Cancel
                </Button>
                <Button
                    variant={"modal"}
                    color={"secondary"}
                    size={"small"}
                    sx={{borderRadius: 2, minWidth: 100, textTransform: "capitalize"}}
                    disabled={!watchdog?.name || !watchdog?.model_name || !watchdog?.model_group || !watchdog?.validation_instructions}
                    onClick={onCreate}
                >
                  Save
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Fade>
      </Modal>
    </>
  )
}
